export default "/images/d14e2ea77b231c2dbe3682f60783fee8.avif";